import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {FormsService} from '../../services/forms.service';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {Page} from '../../../shared/models/page.interface';
import {Forms} from '../../models/forms.interface';
import {FormsSearch} from '../../models/forms-search.interface';
import {MessageService} from '../../../shared/services/message.service';
import {AuthService} from '../../../core/services/auth.service';
import {KfRegistrationService} from '../../../kf-data-entry/services/kf-registration.service';
import {User} from '../../../kf-data-entry/models/user.interface';

@Component({
  selector: 'app-forms',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.scss']
})
export class FormsComponent implements OnInit {

  message = this.router.getCurrentNavigation()?.extras?.state?.message;
  country!: boolean;
  forms!: Page<Forms>;
  user!: User;
  search: FormsSearch = {};
  private page: PageRequest = {page: 0, size: 100, sort: 'year' , direction: 'desc'};
  constructor(private readonly formsService: FormsService,
              private kfRegistrationService: KfRegistrationService,
              private messageService: MessageService,
              readonly router: Router,
              private authService: AuthService) {
    this.country = this.router.url.includes('country');
  }

  ngOnInit(): void {
    this.kfRegistrationService.getUser(this.authService.getEmail()).subscribe(
      data => {
        this.user = data;
        this.search.formType = this.country ? 'Country' : 'System';
        this.updateData();
      }
    );
    if (this.message) {
      this.messageService.showMessage(this.message, 'success');
      this.message = undefined;
    }
  }

  loadForms(event: PageRequest): void {
    this.page = event;
    this.updateData();
  }

  searchForms(search: FormsSearch): void {
    this.search = search;
    this.search.formType = this.country ? 'Country' : 'System';
    if (Object.keys(search).length === 0) {
      this.page = {page: 0, size: 100, sort: 'year', direction: 'asc'};
    }
    this.updateData();
  }

  private updateData(): void {
    this.search.userId = this.country ? this.user?.weeeSystem.country.id : this.user?.weeeSystem.id;
    this.formsService.getAll(this.search, this.page).subscribe(
      data => this.forms = data
    );
  }

}
